/* The existing Sentai lease bundle, using current Shopify variants and plans. The plan cards
   come drawn in the page, one for each plan in order; this makes them selectable. */
if (!customElements.get('st-live-shop')) customElements.define('st-live-shop', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    const button = this.querySelector('#add-bundle');
    const status = this.querySelector('[data-shop-status]');
    const container = this.querySelector('.subscription-container');
    let config;
    try { config = JSON.parse(this.querySelector('[data-shop-config]').textContent); }
    catch { status.textContent = 'Subscription options could not load. Please refresh the page.'; return; }
    const plans = config.plans;
    const available = plan => config.device.available && config.device.id && plan.available && plan.variantId && plan.sellingPlanId && Number.isFinite(plan.price);
    let selected = -1;
    let submitting = false;
    const cards = [...container.querySelectorAll('.subscription-card')];
    const choose = index => {
      if (submitting || !available(plans[index])) return;
      selected = index;
      cards.forEach((card, i) => {
        card.classList.toggle('active', i === index);
        card.setAttribute('aria-checked', String(i === index));
        card.tabIndex = i === index ? 0 : -1;
      });
      button.disabled = false;
      status.textContent = '';
    };
    if (cards.length !== plans.length) { status.textContent = 'Subscription options could not load. Please refresh the page.'; return; }
    cards.forEach((card, index) => {
      card.addEventListener('click', event => { if (!event.target.closest('a')) choose(index); }, { signal });
      card.addEventListener('keydown', event => {
        if (event.target.closest('a')) return;
        if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); choose(index); }
        const delta = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 0;
        if (delta) {
          event.preventDefault();
          const next = (index + delta + plans.length) % plans.length;
          if (available(plans[next])) { choose(next); cards[next].focus(); }
        }
      }, { signal });
    });
    const first = plans.findIndex(available);
    if (first >= 0) choose(first);
    else { button.disabled = true; status.textContent = 'This Sentai bundle is currently unavailable. Please contact us for help.'; }
    this.querySelectorAll('.builder-thumb').forEach((thumb, index) => {
      thumb.tabIndex = 0;
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('aria-label', `View Sentai product image ${index + 1}`);
      const activate = () => { const main = this.querySelector('#builderMainImage'); main.srcset = thumb.dataset.srcset || ''; main.src = thumb.dataset.full; main.alt = thumb.alt; };
      thumb.addEventListener('click', activate, { signal });
      thumb.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(); }
      }, { signal });
    });
    button.addEventListener('click', async () => {
      if (submitting || selected < 0 || !available(plans[selected])) return;
      const plan = plans[selected];
      submitting = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = 'Adding your Sentai bundle…';
      try {
        const response = await fetch(config.addUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [
            { id: config.device.id, quantity: 1 },
            { id: plan.variantId, quantity: 1, selling_plan: plan.sellingPlanId }
          ] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add the Sentai bundle. Please try again.');
        if (this.isConnected) window.location.assign(config.cartUrl);
      } catch (error) {
        status.textContent = error.message || 'Unable to add the Sentai bundle. Please try again.';
        submitting = false;
        button.disabled = false;
      } finally { button.removeAttribute('aria-busy'); }
    }, { signal });
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
});
